module.exports = __webpack_public_path__ + "static/media/product_image_1.0bd660df.png";